import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import ReservationForm from "../components/reservation"

const Reservations = () => {
  return (
    <Layout>
      <SEO
        title="Reservations"
        description="Check availability and request a reservation for Gold Coast Retreat's Tofino cabin rentals at Chesterman Beach."
      />
      <ReservationForm />
    </Layout>
  )
}

export default Reservations